export default {
  buttons: {
    cancel: "منسوخ کریں",
    dismiss: "بند کریں",
    add_waypoint: "منزل مقصود شامل کریں"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  search: {
    title: " تلاش",
    placeholder: "ایک جگہ درج کریں",
    enter_location: "ایک جگہ درج کریں",
    help: {
      inactive: " تلاش"
    }
  },
  filters: {
    title: "فلٹر",
    amenities: {
      title: "سروس اور سہولیات"
    },
    fuels: {
      title: "ایندھن کی اقسام"
    }
  },
  directions: {
    title: "روٹ کی منصوبہ بندی",
    placeholder: {
      destination: "ایک جگہ درج کریں",
      waypoint: "ایک جگہ درج کریں"
    },
    route: {
      title: "روٹ کیے آپشنز",
      avoid_tolls: "ٹول سڑکوں سے بچیں",
      avoid_highways: "موٹر ویز سے بچیں",
      title_corridor: "راستے سے سروس اسٹیشنوں کا فاصلہ"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# دن} other {# ایام}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# منٹ} other {# منٹ}}\
`,
    button: " تلاش"
  },
  locations: {
    title: "مقامات",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} کہاں سے {place}"
  },
  info_window: {
    title: "سائٹ کی تفصیلات",
    services: "سروس اور سہولیات",
    nearby: "قریبی",
    opening_hours: {
      title: "کھولنے اوربند کرنے کا اوقات",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "آخری اپڈیٹ",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "روٹ کی منصوبہ بندی"
  },
  fuels: {
    midgrade_gasoline: "Super Super",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell Diesel"
  },
  amenities: {
    air_and_water: "ہوا",
    atm: "اےٹی ایم (ATM)",
    austrian_highway_sticker: "آسٹرین ہائی وے سٹکر",
    bank_note_acceptor: "کیش جمع کرنےکی مشین",
    bottled_gas: "BBQ پروپین سلینڈر ایکسچینج",
    cafe: "کینٹین",
    carwash: "کار واش",
    clubsmart_card: "کلب سمارٹ کارڈ",
    costa_express: "گرم کھانا",
    credit_card_american_express: "کریڈٹ کارڈ - امریکن ایکسپریس",
    credit_card_diners_club: "کریڈٹ کارڈ -ڈائینر کلب",
    credit_card_mastercard: "کریڈٹ کارڈ - ماسٹر کارڈ",
    credit_card_visa: "کریڈٹ کارڈ - ویزا",
    credit_card: "کریڈٹ کارڈ",
    czech_highway_sticker: "چیک شاہراہ سٹکر",
    euroshell_card: "شیل کارڈ",
    fleet_card_dkv: "فلیٹ کارڈ - DKV",
    fleet_card_eni: "فلیٹ کارڈ - Eni",
    fleet_card_esso: "فلیٹ کارڈ - Esso",
    fleet_card_general: "فلیٹ کارڈ",
    fleet_card_uta: "UTA- فلیٹ کارڈ - ",
    food_offerings: "کھانے کی پیشکش",
    full_service: "اٹینڈنڈ سروس",
    guarded_car_park: "گاریڈڈ پارکنگ",
    hgv_lane: " ٹرک کیلے موزوں",
    high_speed_diesel_pump: "ہائی سپیڈ ڈیزل",
    hot_food: "الکوہل",
    hungarian_highway_sticker: "ہنگیرین شاہراہ سٹکر",
    ido_ticket: "ایڈو ٹکٹ",
    maut_terminal: "ٹول سمارٹ کارڈ",
    parking_lanes: "پارکنگ لین",
    partner_loyalty_accepted: "پارٹنر لوئیلیٹی اکسپٹڈیڈ",
    pay_at_pump: "پمپ پر ادائیگی کریں",
    quick_lubes: "کوسٹا ایکسپریس",
    restaurant: "ریسٹورانٹ",
    self_service: "سیلف سروس",
    service_bay: "سروس بے",
    shell_card: "شیل کارڈ",
    shell_club_smart_extra_card: "گولڈ کلب سمارٹ کارڈ",
    shop: "دکان",
    shower: "شاور",
    slovak_highway_sticker: "سلاواکی شاہراہ سٹکر",
    snack_food: "سنیک فوڈ / تیارشدہ فوڈ",
    standard_toilet: "ٹوالیٹ",
    supermarket_fuel_discount: "رعایتی ایندھن",
    toilet: "ٹوالیٹ",
    truck_parking: "ٹرک پارکنگ",
    truckport: "صرف ٹرک کیلے",
    twenty_four_hour: "ے 24  گھنٹے",
    vacuum: "کوئیک لیوب",
    vehicle_identity_system: "گاڑی کا شناختی نظام",
    wifi: "وائی ​​فائی"
  },
  settings: {
    title: "فاصلہ",
    tooltip: "فاصلہ",
    distance_units: {
      title: "میل",
      km: "کلومیٹر",
      miles: "میل"
    },
    language: {
      title: "میری بک مارکس"
    }
  }
}
